<template>
    <b-modal
        v-model="showModal"
        :size="size"
        centered
        hide-footer
        :title="title"
        :header-bg-variant="variant"
        @change="onChange"
    >
        <div class="d-block text-center">
            <slot></slot>
        </div>
    </b-modal>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        variant: {
            type: String,
            default: 'primary',
        },
        size: {
            type: String,
            default: 'lg',
        },
    },
    watch: {
        value() {
            this.showModal = this.value
        },
    },
    data() {
        return {
            showModal: false,
        }
    },
    methods: {
        onChange() {
            this.$emit('input', this.showModal)
        },
    },
}
</script>

<style>
.pad-buttons {
    padding-left: 2rem;
}
</style>
